import { ofType } from "redux-observable";
import { merge, of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { actionActionButtonResetIteration } from "../../hud-action-button/actionHudActionButton";
import { IdActionButtonEntries } from "../../hud-action-button/IdActionButtonEntries";
import { TypeActionThemedEvent } from "../actionThemedEvent";
import { pathSelectSpecialDecorationTabInBuildMenu } from "../paths/pathSelectSpecialDecorationTabInBuildMenu";
export var epicThemedEventRewardCollected = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionThemedEvent.RewardCollected), switchMap(function (action) {
        return merge(pathSelectSpecialDecorationTabInBuildMenu(action, state$, deps), of(actionActionButtonResetIteration(IdActionButtonEntries.ThemedEvents)));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/themed-events/epics/epicThemedEventRewardCollected.ts
// module id = 2425
// module chunks = 3